import { CustomAppLayout } from '../../../layout';

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import React, { useEffect, useState } from 'react';
import { useRouter } from '../../../router';
const _preserve = React.version;
//import { useStore } from '../store';
import { useGlobalState } from '../../../../context/GlobalStateContext';


//import { useStoreAdmin } from '../../../../context/useStoreAdmin';

import { Box, Button, Container, SpaceBetween, Spinner } from '@cloudscape-design/components';
import Header from "@cloudscape-design/components/header";
import { fetchWithWatch } from '../../../../../hooks/fetchWithWatch';
import { ItemUser } from '../../../../../resources/types';
import { addNotification, addNotificationStatus, buildBreadcrumbItems, getCookie, getUrlVersion, setData, setLoading } from '../../../../commons/functions';


import PieChart from "@cloudscape-design/chart-components/pie-chart";
import Highcharts from "highcharts";
import { mdiAccountArrowDown } from '@mdi/js';
import Icon from '@mdi/react';


type ItemUserEnable = {
    idUser: number;
    name: string;
    lastName: string;
    RUT: string;
    phone1: string;
    email: string;
    CPVLoading: boolean;
    CPSLoading: boolean;
    CPV: number;
    CPS: number;
    CPVEnabled: number;
    CPSEnabled: number;
    debt45: number;
}

export const CommPollsRollPage = () => {
    const { menu, parameters } = useGlobalState();
    const [users, setUsers] = useState<ItemUserEnable[]>([]);
    const [loadingSmall, setLoadingSmall] = useState<boolean>(false);
    const [filteringText, setFilteringText] = useState("");
    const [user, setUser] = useState<any>();
    const [missing, setMissing] = useState<number>(0);
    useGlobalState();
    const { navigate } = useRouter();
    useEffect(() => {
        // 1. Define the interval logic
        const intervalId = setInterval(() => {
            console.log('Interval running every 3 seconds...');
            handleGetUsers(2);
        }, 10000);

        // 2. Return the cleanup function
        // This runs automatically when the component unmounts
        return () => {
            console.log('Component unmounted, clearing interval.');
            clearInterval(intervalId);
        };
    }, []); // Empty dependency array ensures this runs only on mount
    const handleGetUser = async (idUser: number) => {
        try {
            setLoading(true)
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/admin/polls/userprofile',
                    'JWT': getCookie("JWT"),
                    //  
                },
                body: JSON.stringify({ idUser: idUser }),
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const data = await response.json();
            addNotificationStatus(data, setData);
            if (data.code == 0) {
                setUser(data.user);
            }
        } catch (error: any) {
            //addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
        } finally {
            setLoading(false)
        }

    }

    const handleGetUsers = async (loader: number) => {
        try {
            if (loader === 1) {
                setLoading(true)
            } else if (loader === 2) {
                setLoadingSmall(true);
            }
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/admin/polls/enabled',
                    'JWT': getCookie("JWT"),
                    //  
                },
                body: JSON.stringify({}),
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const data = await response.json();
            addNotificationStatus(data, setData);
            if (data.code == 0) {
                setUsers(data.users.map((u: ItemUser) => ({ ...u, CPVLoading: false, CPSLoading: false })));
            }
        } catch (error: any) {
            addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
        } finally {
            if (loader === 1) {
                setLoading(false)
            } else if (loader === 2) {
                setLoadingSmall(false);
            }
        }

    }
    const handleGetUsersFilter = async (body: any) => {
        try {
            if (body.idGroup === 2209071) {
                setUsers(prev => prev.map(u => u.idUser === body.idUser ? { ...u, CPVLoading: true } : u))
            }
            if (body.idGroup === 2209072) {
                setUsers(prev => prev.map(u => u.idUser === body.idUser ? { ...u, CPSLoading: true } : u))
            }
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/admin/polls/enable',
                    'JWT': getCookie("JWT"),
                    //  
                },
                body: JSON.stringify(body),
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const data = await response.json();
            addNotificationStatus(data, setData);
            if (data.code == 0) {
                setUsers((prevUsers) =>
                    prevUsers.map((user) =>
                        user.idUser === data.users[0].idUser ? data.users[0] : user
                    )
                );
                //setUsers(data.users);
            }
        } catch (error: any) {
            //addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
        } finally {

            if (body.idGroup === 2209071) {
                setUsers(prev => prev.map(u => u.idUser === body.idUser ? { ...u, CPVLoading: false } : u))
            }
            if (body.idGroup === 2209072) {
                setUsers(prev => prev.map(u => u.idUser === body.idUser ? { ...u, CPSLoading: false } : u))
            }

        }

    }

    /*
        const sortedUsers = [...users].sort((a, b) => {
            // 1. Sort by lastName first
            const lastNameCompare = a.lastName.localeCompare(b.lastName, 'es', { sensitivity: 'base' });
            if (lastNameCompare !== 0) {
                return lastNameCompare;
            }
            return a.name.localeCompare(b.name, 'es', { sensitivity: 'base' });
        });
        */
    useEffect(() => {
        handleGetUsers(1);
    }, []);


    const [currentPageIndex, setCurrentPageIndex] = useState(1);


    const CPVTotal = users.filter(u => u.CPV === 1).length;
    const CPSEnabledTotal = users.filter(u => u.CPSEnabled === 1).length;
    const CPVEnabledTotal = users.filter(u => u.CPVEnabled === 1).length;
    const CPSTotal = users.filter(u => u.CPS === 1).length;



    return (
        <CustomAppLayout
            toolsHide={true}
            breadcrumbs={
                <BreadcrumbGroup
                    items={buildBreadcrumbItems(menu)}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={
                <SpaceBetween size="s">

                    <Header variant="h1" actions={
                        <SpaceBetween direction="horizontal" size="xs">
                        </SpaceBetween>
                    } description={`${users.length} usuarios`}>
                        Padrón electoral {loadingSmall ? <Spinner /> : null}</Header>
                    <Box textAlign="center" padding="l">
                        <SpaceBetween direction="horizontal" size="xs" alignItems="center">
                            <Container
                                header={<Header variant="h3"
                                    actions={
                                        <Button variant="primary" onClick={() => handleGetUsers(2)}><Icon path={mdiAccountArrowDown} size={1} /></Button>
                                    }
                                    description={<><strong>Asistencia:</strong> Club de Planeadores de Vitacura</>}>Vitacura</Header>}
                            >

                                <PieChart
                                    chartMinWidth={300}
                                    highcharts={Highcharts}
                                    innerAreaTitle={`${(CPVEnabledTotal / CPVTotal * 100).toFixed(2)}%`}
                                    innerAreaDescription={`${CPVEnabledTotal}/${CPVTotal}`}
                                    series={{
                                        type: "donut",
                                        name: "CPV", // Name of the series
                                        data:
                                            [
                                                { name: "OK", y: CPVEnabledTotal },
                                                { name: "KO", y: CPVTotal - CPVEnabledTotal },
                                            ]
                                    }}
                                    filter={{ seriesFilter: false }}
                                    tooltip={{
                                        details({ segmentValue, totalValue }) {
                                            return [
                                                {
                                                    key: "Votos obtenidos",
                                                    value: `${segmentValue} ${segmentValue === 1 ? "voto" : "votos"}`
                                                },
                                                {
                                                    key: "Porcentaje",
                                                    value: `${totalValue > 0 ? ((segmentValue / totalValue) * 100).toFixed(1) : 0}%`
                                                }
                                            ];
                                        }
                                    }}
                                    ariaLabel="Storage usage chart"
                                    ariaDescription="Pie chart showing storage usage by category."
                                />

                            </Container>
                            <Container
                                header={<Header variant="h1"

                                    description={<><strong>Asistencia:</strong> Club de Planeadores de Santiago</>}
                                >Santiago</Header>}
                            >
                                <PieChart
                                    chartMinWidth={300}
                                    highcharts={Highcharts}
                                    innerAreaTitle={`${(CPSEnabledTotal / CPSTotal * 100).toFixed(2)}%`}
                                    innerAreaDescription={`${CPSEnabledTotal}/${CPSTotal}`}
                                    series={{
                                        type: "donut",
                                        name: "CPS", // Name of the series
                                        data:
                                            [
                                                { name: "OK", y: CPSEnabledTotal },
                                                { name: "KO", y: CPSTotal - CPSEnabledTotal },
                                            ]
                                    }}
                                    filter={{ seriesFilter: false }}
                                    tooltip={{
                                        details({ segmentValue, totalValue }) {
                                            return [
                                                {
                                                    key: "Votos obtenidos",
                                                    value: `${segmentValue} ${segmentValue === 1 ? "voto" : "votos"}`
                                                },
                                                {
                                                    key: "Porcentaje",
                                                    value: `${totalValue > 0 ? ((segmentValue / totalValue) * 100).toFixed(1) : 0}%`
                                                }
                                            ];
                                        }
                                    }}
                                    ariaLabel="Storage usage chart"
                                    ariaDescription="Pie chart showing storage usage by category."
                                />
                            </Container>


                        </SpaceBetween >
                    </Box>
                </SpaceBetween >
            }
        />
    )
};
